export default __webpack_public_path__ + "assets/icon-receipt.a253ec1d.webp";